import { render, staticRenderFns } from "./SettlementOptionsMatrix.vue?vue&type=template&id=a2684288&"
import script from "./SettlementOptionsMatrix.vue?vue&type=script&lang=js&"
export * from "./SettlementOptionsMatrix.vue?vue&type=script&lang=js&"
import style0 from "./SettlementOptionsMatrix.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports